export default {"src":"/_next/static/media/order-process-step2.ae572b1f.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};